const images = (folder, lang) => {
    let listImg = [];
    if (process.env.NODE_ENV === 'development') {
        for(let i = 11; i <= 71; i++){
            listImg.push(`http://localhost:8081/media/${lang}/videoOnyx/video_site_onyx_${i.toString().padStart(5, '0')}.jpg`)
        }
    } else {
        for(let i = 11; i <= 71; i++){
            listImg.push(`https://www.dioptase.fr/media/${lang}/videoOnyx/video_site_onyx_${i.toString().padStart(5, '0')}.jpg`)
        }
    }
    return listImg;
}
export default images;
